export const GET_QUESTIONS = "GET_QUESTIONS";
export const GET_QUESTION_BY_ID = "GET_QUESTION_BY_ID";
export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const DELETE_QUESTION = "DELETE_QUESTION";
export const CREATE_QUESTION = "CREATE_QUESTION";
